<template>
  <div>
    <div
      v-if="isBcom"
      class="margin-bottom-xs"
    >
      <ul
        v-if="marketPlaceItemEnabled && notes.length"
        class="margin-bottom-xs"
      >
        <li
          v-for="note in notes"
          :key="note"
          class="margin-left-xs"
          data-testid="note"
          v-html="sanitize(note)"
        />
      </ul>

      For complete details related to this item, visit our
      <a
        class="link-body"
        :href="hasSplHandlingAttrbs ? faqLinkLtl : faqLink"
        target="_blank"
      >FAQ</a>.
    </div>
    <span class="medium">
      Your security is our number one concern.
    </span>
    <p>
      To report suspicious activity, please reach out to {{ brandName }} at
      {{ phoneNumber }} or
      <a
        class="link-body"
        :href="concernReportLink"
        target="_blank"
      >click here</a>
      to report online.
    </p>
  </div>
</template>

<script setup>
import { sanitize } from '@vue-util/sanitize';
import { brandName, marketPlace } from 'config';
import { useBrand } from '@composables/useBrand';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import { useFeatureEligibility } from '@modules/featureControl';
import { useMarketPlace } from '@composables/useMarketPlace';

const {
  notes,
} = useCommonProductGetters();

const {
  phoneNumber, concernReportLink, faqLink, faqLinkLtl,
} = marketPlace;
const { isBcom } = useBrand();
const {
  marketPlaceItemEnabled,
} = useFeatureEligibility();
const { hasSplHandlingAttrbs } = useMarketPlace();
</script>
